type PropTypes = {
  className?: string
}

const PadlockIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 28"
      className={className}
    >
      <path
        fill="currentColor"
        d="M17.588 12.14h-1.882V6.493a5.647 5.647 0 0 0-11.294 0v5.647H2.529a1.882 1.882 0 0 0-1.882 1.882v11.294A1.882 1.882 0 0 0 2.529 27.2h15.06a1.882 1.882 0 0 0 1.882-1.883V14.022a1.883 1.883 0 0 0-1.883-1.882ZM6.294 6.493a3.765 3.765 0 1 1 7.53 0v5.647h-7.53V6.493Zm11.294 18.823H2.53V14.022h15.06v11.294Z"
      />
    </svg>
  )
}

export default PadlockIcon
